import React from "react";
import Logo from "../assets/images/logos/Material Index Logo Final-06.png";

function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 px-6">
        {/* Logo and Description */}
        <div>
          <div className="flex items-center space-x-3 mb-4">
            <img
              src={Logo} // Replace with your logo path
              alt=""
              className="h-10"
            />
            {/* <h1 className="text-2xl font-bold">Material</h1>
            <h1 className="text-2xl text-blue-400">Index</h1> */}
          </div>
          {/* <p className="text-gray-400">
            Greenosoft is basically an IT-based firm. We basically give App &
            Web solutions to our clients according to their taste and need.
          </p> */}
          <div className="flex space-x-4 mt-4">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook text-2xl hover:text-blue-600"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram text-2xl hover:text-pink-500"></i>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin text-2xl hover:text-blue-500"></i>
            </a>
          </div>
        </div>

        {/* Useful Links */}
        <div>
          <h2 className="text-xl font-bold mb-4 border-b-2 border-blue-500 inline-block">
            Useful Links
          </h2>
          <ul className="space-y-2">
            <li>
              <a
                href="/about"
                className="text-gray-400 hover:text-blue-400"
              >
                About Us
              </a>
            </li>
            <li>
              <a
                href="/products"
                className="text-gray-400 hover:text-blue-400"
              >
                Product
              </a>
            </li>
            <li>
              <a
                href="/contact"
                className="text-gray-400 hover:text-blue-400"
              >
                Contact Us
              </a>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h2 className="text-xl font-bold mb-4 border-b-2 border-blue-500 inline-block">
            Contact
          </h2>
          <p className="text-gray-400">
            <strong>Address:</strong> House 75, Block B, Road #1, Niketon,
            Dhaka-1212
          </p>
          <p className="text-gray-400">
            <strong>Email:</strong> info@materialsindexbd.com
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
